export default {
  superDesktop: 'सुपर एडमिन पैनल',
  appNotifications: 'ऐप सूचनाएं',
  home: 'घर',
  peopleDirectory: 'लोग',
  peopleList: 'सूचियाँ',
  listDetails: 'सूची विवरण',
  roles: 'भूमिकाओं',
  conversations: 'बातचीत',
  conversationMetrics: 'बातचीत मीट्रिक',
  conversationSettings: 'बातचीत सेटिंग्स',
  businesses: 'व्यवसायों',
  businessDetails: 'व्यावसायिक विवरण',
  campaigns: 'अभियान',
  newSms: 'नया एसएमएस',
  newCampaign: 'नया अभियान',
  campaignDetails: 'अभियान विवरण',
  triggers: 'ट्रिगर्स',
  notifications: 'सूचनाएँ',
  speechToText: 'पाठ परियोजनाओं के लिए भाषण',
  authenticator: 'प्रमाणक',
  forms: 'प्रपत्र',
  events: 'घटनाओं',
  eventDetail: 'घटना विस्तार',
  assistants: 'सहायकों',
  promotors: 'प्रमोटर',
  productsCategories: 'उत्पाद श्रेणियाँ',
  products: 'उत्पादों',
  productsSales: 'उत्पादों की खरीदारी',
  clients: 'ग्राहकों',
  colors: 'रंग',
  containerTypes: 'कंटेनर प्रकार',
  purchases: 'खरीद',
  purchaseDetail: 'खरीद विस्तार',
  sellers: 'विक्रेताओं',
  suppliers: 'आपूर्तिकर्ताओं',
  settings: 'सेटिंग्स',
  details: 'विवरण',
  administrators: 'व्यवस्थापक',
  billing: 'बिलिंग',
  payments: 'भुगतान',
  creditCards: 'क्रेडिट कार्ड',
  newApp: 'नया आवेदन',
  newCompany: 'नई कंपनी',
  newPage: 'नया पेज',
  servicesPerPage: 'प्रति पृष्ठ सेवाएं',
  balance: 'संतुलन',
  loadingTariffs: 'लोडिंग टैरिफ',
  noTariffsOnTheListYet: 'सूची में अभी तक कोई टैरिफ नहीं',
  shortenLink: 'लिंक को छोटा करना',
  addCreditCart: 'क्रेडिट कार्ड जोड़ें',
  addCard: 'कार्ड जोड़ें',
  load: 'भार',
  changePassword: 'पासवर्ड बदलें',
  exit: 'निकासी',
  support: 'समर्थन',
  services: 'सेवाओं',
  value: 'मान',
  addCreditCard: 'क्रेडिट कार्ड जोड़ें',
  createAplication: 'ऐप बनाएं',
  companyNotFound: 'कोई कंपनी नहीं मिली',
  upToDateNotifications: 'आप अपनी सूचनाओं के साथ अद्यतित हैं'
}
